/**
 * Dealflow Deck API
 * API to by used by deck
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DeckCompanyListRequest } from './deck-company-list-request';
import { CompanyJoinRequestsStatusEnum } from './company-join-requests-status-enum';

export interface CompanyJoinRequestsRequest {
  status?: CompanyJoinRequestsStatusEnum;
  company: DeckCompanyListRequest;
}
export namespace CompanyJoinRequestsRequest {}
